module.exports = __webpack_public_path__ + "img/CRO-Melda-Maesarach-new.a3bb8f14.jpg";